interface TorizonReadiness {
  ready: boolean;
  warnings: string[];
  errors: string[];
}

// The payload arrives over the websocket, so its shape is never guaranteed by
// the compiler — this is the actual runtime check the reducer relies on.
export const isTorizonReadiness = (input: any): input is TorizonReadiness => {
  return (
    input != null &&
    typeof input.ready === 'boolean' &&
    Array.isArray(input.warnings) &&
    Array.isArray(input.errors)
  );
};

export default TorizonReadiness;

export const mockTorizonReadiness = {
  ready: true,
  warnings: [],
  errors: [],
} as TorizonReadiness;
